import { Platform } from "react-native";
import { initializeApp } from "firebase/app";
import {
  Analytics,
  getAnalytics,
  logEvent as logWebEvent,
} from "firebase/analytics";
import analytics from "@react-native-firebase/analytics";
import { FirebaseAnalytics } from "@firebase/analytics-types";
import { useCallback, useMemo } from "react";

export const useFirebaseInitialization = (config: any) => {
  const app = useMemo(() => {
    if (!config) return null;
    return initializeApp(config);
  }, [config]);

  const analyticsInstance = useMemo(() => {
    if (!app) return null;
    return Platform.OS === "web" ? getAnalytics(app) : analytics();
  }, [app]);

  const logEvent = useCallback(
    async (eventName: string, params = {}) => {
      try {
        if (!analyticsInstance) return;

        if (Platform.OS === "web") {
          logWebEvent(analyticsInstance as Analytics, eventName, params);
        } else {
          (analyticsInstance as FirebaseAnalytics).logEvent(eventName, params);
        }
      } catch (error) {
        console.error("Error logging event:", error);
      }
    },
    [analyticsInstance]
  );

  return { logEvent };
};
